import api from "../api";

export default function getAuditEvents(userId, page, perPage) {
  return api.get(
    `/admin/users/${userId}/audit-events?page=${page}&perPage=${perPage}`
  );
}
